import React, { useState } from "react";
import "../AllocationCaseDetails.scss";
import Tabs from "../../../../Reuseable/Tabs/Tabs";
import SmsInteraction from "../../../../components/AllocationComp/SmsInteraction/SmsInteraction";
import WhatsappReaction from "../../../../components/AllocationComp/WhatsappReaction/WhatsappReaction";
import AiCallConversation from "../../../../components/AllocationComp/AiCallConversation/AiCallConversation";
import ManualCallLogs from "../../../../components/AllocationComp/ManualCallLogs/ManualCallLogs";
import {
  IdcardOutlined,
  MessageOutlined,
  UserOutlined,
} from "@ant-design/icons";
import upArrow from "../../../../assets/Icons/UpArrow.svg";
import downArrow from "../../../../assets/Icons/dropdown.svg";
import sentiment from "../../../../assets/Icons/sentiment.svg";
import TableFilterDropdown from "../../../../Reuseable/TableFilter/TableFilter";
import PanelCard from "../../../../Pages/DashboardPage/components/PanelCard";
import { formatCurrency } from "../../../../assets/helpers";
import { useSelector } from "react-redux";

const EMPTY = "—";

const BasicDetails = ({data}) => {
  const [selectedTab, setSelectedTab] = useState("SMS Interaction");
  const [showTable, setShowTable] = useState(true);
  const {format} = useSelector(state=>state.priceFormat);

  const handleArrowClick = () => setShowTable((prev) => !prev);

  const information = [
    { title: "Customer Name", info: data?.customer_name },
    { title: "Loan Number", info: data?.loan_no, mono: true },
    { title: "Customer Unique ID", info: data?.customer_id, mono: true },
    { title: "Contact number", info: data?.cust_mobile_no, mono: true },
    { title: "Loan Type", info: null },
    {
      title: "Amount Overdue",
      info: formatCurrency(data?.amount_overdue, format),
      mono: true,
    },
    { title: "Portfolio", info: data?.bank },
    { title: "CRIF Score", info: null },
  ];

  /* TODO: placeholder content - none of these four come from `data`. */
  const profileData = [
    { title: "Persona Type", info: "High Risk", chip: "is-risk" },
    { title: "Sentiment", info: "Frustrated", chip: "is-amber", icon: sentiment },
    { title: "Online Timings", info: "Active 4 PM – 8 PM" },
    {
      title: "Income Source (Derived)",
      info: "Private Job, Low-Income Area (₹20k–30k/Month)",
    },
  ];

  const tabOptions = [
    { label: "SMS Interaction", value: "SMS Interaction" },
    { label: "WhatsApp Interaction", value: "WhatsApp Interaction" },
    { label: "AI Call Conversations", value: "AI Call Conversations" },
    { label: "Manual Call Logs", value: "Manual Call Logs" },
  ];

  const collapsible =
    selectedTab === "AI Call Conversations" ||
    selectedTab === "Manual Call Logs";

  return (
    <div className="caseBasicDetails">
      <PanelCard
        title="Basic Customer & Loan Info"
        icon={<IdcardOutlined />}
        accent="brand"
      >
        {/* was two hardcoded slices - information.slice(0,4) and (4,8) - in
            separate rows joined by a divider, with the cell borders keyed to
            nth-child(4)/(8) */}
        <div className="caseGrid">
          {information.map(({ title, info, mono }) => (
            <div className="caseField" key={title}>
              <span className="caseField__label">{title}</span>
              <span
                className={`caseField__value${mono ? " is-mono" : ""}${
                  info ? "" : " is-empty"
                }`}
              >
                {info || EMPTY}
              </span>
            </div>
          ))}
        </div>
      </PanelCard>

      <PanelCard
        title="Persona & Behavioral Profile"
        icon={<UserOutlined />}
        accent="brand"
      >
        {/* four fields, one exact row of the shared grid - the same card
            width as the info panel above. The derived income line wraps
            inside its card rather than claiming a row of its own, which
            left an empty slot beside the three short values. */}
        <div className="caseGrid">
          {profileData.map(({ title, info, chip, icon }) => (
            <div className="caseField" key={title}>
              <span className="caseField__label">{title}</span>
              <span className="caseField__value">
                {chip ? (
                  <span className={`caseChip ${chip}`}>
                    {icon && <img src={icon} alt="" />}
                    {info}
                  </span>
                ) : (
                  info
                )}
              </span>
            </div>
          ))}
        </div>
      </PanelCard>

      <PanelCard
        title="Interaction"
        icon={<MessageOutlined />}
        accent="brand"
        className="interactionPanel"
        actions={
          <div className="segmentedTabs">
            <Tabs
              options={tabOptions}
              active={selectedTab}
              onChange={setSelectedTab}
              selectorBreakpoint={700}
            />
          </div>
        }
      >
        <div className="interactionHead">
          <h4>{selectedTab}</h4>

          <div className="interactionTools">
            <TableFilterDropdown
              sections={[
                ...(selectedTab === "SMS Interaction" ||
                selectedTab === "WhatsApp Interaction" ||
                selectedTab === "AI Call Conversations" ||
                selectedTab === "Manual Call Logs"
                  ? [
                      {
                        key: "status",
                        label: "Status",
                        options: [
                          { label: "Not Answered", value: "not_answered" },
                          { label: "Call Picked", value: "call_picked" },
                          { label: "Not Reachable", value: "not_reachable" },
                        ],
                      },
                    ]
                  : []),

                ...(selectedTab === "AI Call Conversations" ||
                selectedTab === "Manual Call Logs"
                  ? [
                      {
                        key: "sentiment",
                        label: "Sentiment",
                        options: [
                          { label: "Neutral", value: "neutral" },
                          { label: "Disengaged", value: "disengaged" },
                          { label: "Frustrated", value: "frustrated" },
                          { label: "Cooperative", value: "cooperative" },
                          { label: "Unresponsive", value: "unresponsive" },
                          { label: "Irritated", value: "irritated" },
                          { label: "Avoidant", value: "avoidant" },
                        ],
                      },
                    ]
                  : []),

                ...(selectedTab === "Manual Call Logs"
                  ? [
                      {
                        key: "disposition",
                        label: "Disposition",
                        min: 20,
                        max: 100,
                      },
                    ]
                  : []),
              ]}
              onApply={(filters) => console.log("Filters applied", filters)}
            />

            {collapsible && (
              <button
                type="button"
                className="arrow"
                onClick={handleArrowClick}
                aria-expanded={showTable}
                title={showTable ? "Hide" : "Show"}
              >
                <img src={showTable ? upArrow : downArrow} alt="" />
              </button>
            )}
          </div>
        </div>

        <div className="interactionBody">
          {selectedTab === "SMS Interaction" && <SmsInteraction />}
          {selectedTab === "WhatsApp Interaction" && <WhatsappReaction />}

          {showTable && (
            <>
              {selectedTab === "AI Call Conversations" && (
                <AiCallConversation />
              )}
              {selectedTab === "Manual Call Logs" && <ManualCallLogs caseData={data}/>}
            </>
          )}
        </div>
      </PanelCard>
    </div>
  );
};

export default BasicDetails;
